/*
 * Infinite scroll for the collection product grid.
 *
 * All the mechanics live in InfiniteScrollController; this only describes how the
 * grid differs — where to fetch from, what to pull out of the response, and where
 * to put it.
 *
 * Lives inside #ProductGridContainer, which facets.js replaces wholesale on every
 * filter or sort change. Being a custom element means connectedCallback re-runs
 * against the new page automatically, so there is no separate facet lifecycle to
 * subscribe to.
 */
if (!customElements.get('collection-infinite-scroll')) {
  customElements.define(
    'collection-infinite-scroll',
    class CollectionInfiniteScroll extends HTMLElement {
      connectedCallback() {
        // The controller is only loaded by sections that render a scroll target.
        // Without it, stay hidden and leave the paginated links in charge.
        if (typeof InfiniteScrollController === 'undefined') return;

        const gridId = this.dataset.gridId || 'product-grid';
        const grid = document.getElementById(gridId);
        if (!grid) return;

        this.controller = new InfiniteScrollController({
          trigger: this,
          dataSource: this,

          buildUrl: (page) => {
            const url = new URL(window.location.href);
            url.searchParams.set('section_id', this.dataset.section);
            url.searchParams.set('page', page);
            return url;
          },

          extract: (doc) => {
            const incomingGrid = doc.getElementById(gridId);
            if (!incomingGrid) return null;
            const incomingSelf = doc.querySelector('collection-infinite-scroll');
            return {
              nodes: Array.from(incomingGrid.children),
              visibleCount: parseInt(incomingSelf?.dataset.visibleCount, 10) || 0,
            };
          },

          // Deliberately no initializeScrollAnimationTrigger call. Appended cards
          // arrive without .scroll-trigger--offscreen, so the reveal animation
          // already runs on insertion. Re-running the initialiser over the grid
          // would observe every card, and its callback ADDS that class to anything
          // not currently on screen — re-hiding cards already scrolled past.
          append: (nodes) => grid.append(...nodes),
        });

        this.controller.start();
      }

      disconnectedCallback() {
        this.controller?.destroy();
        this.controller = undefined;
      }
    }
  );
}
